import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AmcIconifyModule} from 'amc-common-components';
import {LoaderMiniComponent} from '@shared/components/loaders/loader-mini/loader-mini.component';

@NgModule({
	imports: [CommonModule, AmcIconifyModule],
	exports: [LoaderMiniComponent],
	declarations: [LoaderMiniComponent],
})
export class LoaderMiniModule {}
